import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=49bb45c7&scoped=true"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"
import style0 from "./Hall.vue?vue&type=style&index=0&id=49bb45c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0__css-load_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb45c7",
  null
  
)

export default component.exports